import { Div, CollectionView } from "@tblabs/truffle";
import { Calendar } from "../../../../../Components/Calendar/Calendar";
import { CalendarEntry } from "../../../../../Components/Calendar/CalendarEntry";
import { Order } from "../../../../../Models/Order";
import { Router } from "../../../../../Services/Router";
import { EventView } from "./EventView";
import { StepEventType } from "../../../../../Steps/Step/StepEvent";


export class CalendarView extends Div
{
    constructor(private _router: Router, private orders: CollectionView<Order>)
    {
        super();
        this.TextAlignCenter();

        // const filter = new RefString().Storable("calendar-filter");

        const allOrdersEvents = this.orders.Items.flatMap(order => order.AsEvents)
            .filter(x => [StepEventType.PackageToCustomer, StepEventType.PersonalPickup, StepEventType.PersonalReturn].includes(x.Type))

        const calendarEntries: CalendarEntry[] = allOrdersEvents
            .map(event =>
                new CalendarEntry(event.Date, () => [new EventView(this._router, event)])
            );

        this.Append(
            // new Select(filter, { "Wszystkie": "all", "Ważne": "important" }),
            new Calendar(calendarEntries),
        );
    }
}
